module.exports = __webpack_public_path__ + "img/AnwarAbbas-nologo.f6f4ae51.png";